export default __webpack_public_path__ + "static/media/b1.6389f690.jpg";